// src/modules/auth/types/auth.error.types.ts

export enum AuthErrorType {
  INVALID_CREDENTIALS = "Invalid Credentials",
  SESSION_EXPIRED = "Session Expired",
  UNAUTHORIZED = "Unauthorized Access",
  REGISTRATION_FAILED = "Registration Failed",
  PASSWORD_CHANGE_FAILED = "Password Change Failed",
  TOKEN_REFRESH_FAILED = "Token Refresh Failed",
  NETWORK_ERROR = "Network Error",
  VALIDATION_ERROR = "Validation Error",
  SERVER_ERROR = "Server Error",
}

export const AUTH_ERROR_TYPE = "Authentication Error" as const;
